import { render, staticRenderFns } from "./DocumentLabel.vue?vue&type=template&id=a32f1f06"
import script from "./DocumentLabel.vue?vue&type=script&lang=ts"
export * from "./DocumentLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports